<template>
  <div class="app-header fixed">
    <el-row>
      <el-col
        :span="3"
        :offset="3"
      >
        <div class="flex-vc logo">
          <img
            src="~@/assets/images/logo.png"
            alt="心晴门诊"
            @click="goHome"
          />
        </div>
      </el-col>
      <el-col
        :span="13"
        :offset="1"
      >
        <el-row class="nav">
          <el-col
            :span="4"
            v-for="i of nav"
            :key="i.name"
            class="nav-item"
            :class="{active: activeNav === i.name}"
            @click.native="viewPage({ name: i.name })"
          >{{ i.label }}</el-col>
        </el-row>
      </el-col>
      <el-col
        :span="4"
        class="info"
      >
        <div class="info-item">
          <span class="iconfont icon-tel_fill"></span>
          <span>020-82382600</span>
        </div>
        <div class="info-item">
          <span class="iconfont icon-clock"></span>
          <span>09:00~18:00</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { nav } from 'config/code'

export default {
  name: 'app-header',
  data() {
    return {
      nav: nav,
      activeNav: 'home'
    }
  },
  watch: {
    $route(to) {
      this.viewPage(to)
    }
  },
  methods: {
    viewPage(route) {
      window.scrollTo(0, 0)
      this.$router.push({ ...route })
      const hit = this.nav.find(n => route.name.startsWith(n.name))
      if (hit) {
        this.activeNav = hit.name
      }
    },
    goHome() {
      this.viewPage({ name: 'home' })
    }
  },
  mounted() {
    const pathName = window.location.hash.split('/')[1]
    const hit = this.nav.find(i => pathName === i.name)
    if (hit) {
      this.activeNav = hit.name
    }
  }
}
</script>

<style lang='less' scoped>
@import '~variables.less';

@app-header-height: 60px;

.app-header {
  height: @app-header-height;
  line-height: @app-header-height;
  background-color: #fff;
  // border-bottom: 1px solid @line-color-light;
  box-shadow: 1px 1px 1px @line-color-light;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
}

.logo {
  height: @app-header-height;
  line-height: @app-header-height;
  img{
    width: 100%;
    height: 45px;
    object-fit: contain;
  }
  &:hover {
    cursor: pointer;
  }
}

.nav-item {
  text-align: center;
  cursor: pointer;
  &.active {
    color: @color-primary;
  }
}

.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: @app-header-height;
}

.info-item {
  line-height: 1.4;
  font-size: 14px;
  span {
    color: @color-gray;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-header.vue